<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr" @selectChange="handChange"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView">
			<div class="BottomTable">
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Expost"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<div class="custom-table">
				<el-table :data="tableData" style="width: 100%;">
					<el-table-column prop="LEVEL1" label="L1" width="80px" />
					<el-table-column prop="LEVEL2" label="L2" width="80px" />
					<el-table-column prop="LEVEL3" label="L3" width="80px" />
					<el-table-column prop="LEVEL4" label="L4" width="80px" />
					<el-table-column prop="CostName" label="类型名称" />
					<el-table-column prop="CostTypeName" label="价格类型" width="120px" />
					<el-table-column prop="CostValue" label="价格(元)" width="120px" />
					<el-table-column prop="IsSuitIMSByCusName" label="是否适用IMS" width="120px" />
					<el-table-column prop="ValiDate" label="启效时间" width="150px">
						<template slot-scope="scope">
							{{scope.row.ValiDate?scope.row.ValiDate.substring(0,10):''}}
						</template>
					</el-table-column>
					<el-table-column prop="PriorityLevel" label="优先级" width="80px" />
					<el-table-column prop="RelationType" label="功能范围" show-overflow-tooltip width="130px" />
					<el-table-column label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" style="color:#00266D" v-if="qx.update"
								@click="handEditor(scope.row)">修改</el-button>
							<el-button type="text" style="color:#E71D43" v-if="qx.del"
								@click="handDel(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
		<DialogFrom width="750px" :title="`修改`" :OKASCAN="true" :dialogVisible="dialogShow" @cancel="cancelEditor"
			@dialogOK="dialogOKEditor">
			<FromComm :FromArr="FromArrEditor"></FromComm>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import DialogFrom from '../../../components/dialog-from.vue'
	import Pagination from '../../../components/pagination.vue'
	import CommonbtnUpLoad from '../../../components/common-upload.vue'
	import Commontable from '../../..//components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import FromArrEditor from './FormData/FromArrEditor'
	import utils from '../../../common/utils'
	import {
		GetCostSummaryList,
		InfoCostSummary,
		EditCostSummary,
		DeleteCostSummary,
		GetHelperLevel1,
		GetHelperLevel2,
		GetHelperLevel3,
		GetHelperLevel4,
		ExportCostSummary
	} from '@/api/newsapi'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				FromArrEditor: [],
				tableCurr: null,
				tableData: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: false,
					daoc: false,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.QX();
			this.GetHelperLevel();
			this.getData();
		},
		methods: {
			async getData() {
				this.query.leveL1 = this.FromArr[0].modelvalue;
				this.query.leveL2 = this.FromArr[1].modelvalue;
				this.query.leveL3 = this.FromArr[2].modelvalue;
				this.query.leveL4 = this.FromArr[3].modelvalue;
				this.query.CostName = this.FromArr[4].modelvalue;
				this.query.Customer = this.FromArr[5] ? this.FromArr[5].modelvalue : '';
				this.query.Hospital = this.FromArr[6] ? this.FromArr[6].modelvalue : '';
				let {
					code,
					data
				} = await GetCostSummaryList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 获取level
			async GetHelperLevel(p = {}, k = 0) {
				let res = null;
				switch (k) {
					case 0:
						res = await GetHelperLevel1(p);
						break;
					case 1:
						res = await GetHelperLevel2(p);
						break;
					case 2:
						res = await GetHelperLevel3(p);
						break;
					case 3:
						res = await GetHelperLevel4(p);
						break;
				}
				if (res.code == 0) {
					this.FromArr[k].options = []
					res.data.map((item, index) => {
						this.FromArr[k].options.push({
							key: item.value,
							value: item.key
						})
					})
				}
			},
			handChange(e) {
				if (e === 0) {
					this.GetHelperLevel({
						LEVEL1: this.FromArr[0].modelvalue,
					}, 1);
					this.FromArr[1].modelvalue = '';
					this.FromArr[2].modelvalue = '';
					this.FromArr[3].modelvalue = '';
				}
				if (e === 1) {
					this.GetHelperLevel({
						LEVEL1: this.FromArr[0].modelvalue,
						LEVEL2: this.FromArr[1].modelvalue,
					}, 2);
					this.FromArr[2].modelvalue = '';
					this.FromArr[3].modelvalue = '';
				}
				if (e === 2) {
					this.GetHelperLevel({
						LEVEL1: this.FromArr[0].modelvalue,
						LEVEL2: this.FromArr[1].modelvalue,
						LEVEL3: this.FromArr[2].modelvalue
					}, 3);
					this.FromArr[3].modelvalue = '';
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			//删除
			handDel(row) {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = await DeleteCostSummary({
						csdid: row.CSDID
					});
					loading.close();
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				}).catch(() => {});
			},
			//编辑
			async handEditor(row) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.tableCurr = row.CSDID;
				let res = await InfoCostSummary({
					csdid: row.CSDID
				});
				loading.close();
				if (res.code == 0) {
					this.$set(this.FromArrEditor[0], 'modelvalue', res.data.LEVEL3);
					this.$set(this.FromArrEditor[1], 'modelvalue', res.data.LEVEL4);
					this.$set(this.FromArrEditor[2], 'modelvalue', res.data.CostTypeName);
					this.$set(this.FromArrEditor[3], 'modelvalue', res.data.CostPrice || res.data.CostRate);
					this.dialogShow = true;
					this.$forceUpdate();
				} else {
					this.$message.error(res.message);
				}
			},
			//取消编辑
			cancelEditor() {
				this.FromArrEditor.map(item => {
					item.modelvalue = '';
					return item;
				})
				this.tableCurr = null;
				this.dialogShow = false;
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let params = {
					csdid: this.tableCurr,
					costValue: this.FromArrEditor[3].modelvalue
				};
				let {
					code,
					data,
					message
				} = await EditCostSummary(params);
				loading.close();
				if (code == 0) {
					this.tableCurr = null;
					this.$message.success('已修改');
					this.cancelEditor();
					this.handSearch();
				} else {
					this.$message.error(message);
				}
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			async Expost() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportCostSummary(this.query)
				if (resexprot) {
					let date = new Date()
					utils.downloadFile(resexprot, "价格汇总" + date.getTime(), "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close();
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 159) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 161) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						}
					})
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		min-height: 88px;
		height: auto;
		padding-bottom: 20px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 24px;
			//margin-top: 20px;
		}
	}

	.ContentView {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 12px;
		}

		.custom-table {
			padding: 0px 24px 24px 24px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}

			/deep/.el-table__body {
				td {
					padding: 0px 0 !important;
					cursor: pointer;
				}
			}
		}
	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}
</style>